// extracted by mini-css-extract-plugin
export default {"loaderContainer":"basic-loader_loaderContainer__AWEqF","innerContainer":"basic-loader_innerContainer__BnC2+","spin":"basic-loader_spin__SWupY"};